import { createApp } from 'vue';
import Toast from '../components/Toast.vue';

function showToast(message, duration = 3000) {
  const toastApp = createApp(Toast, { message, duration });
  const mountNode = document.createElement('div');
  document.body.appendChild(mountNode);
  toastApp.mount(mountNode);

  setTimeout(() => {
    toastApp.unmount();
    document.body.removeChild(mountNode);
  }, duration + 500); // 留出淡出动画的时间
}

export default {
  show: showToast
};